<template>


  <div class="cp-usage" v-if="chargingPoint">
    <report-usages-list :charging-point-id="chargingPoint?.id" show-no-energy  />
  </div>
</template>

<script>
import ReportUsagesList from "@/components/elements/ReportUsagesList.vue";

export default {
  components: {ReportUsagesList},



  mounted() {

  },



  watch: {

  },

  computed:  {
    chargingPoint() {
      return this.$parent.chargingPoint
    },

  },

  methods: {

  }
}
</script>

<style lang="scss">
.cp-usage {

}

</style>
